<template>
    <div class="agent-menu-container">
      <div class="agent-menu">
        <div 
          v-for="(item, index) in menuItems" 
          :key="index"
          class="menu-item"
          :class="{ 'active': selectedItem === `page${index + 1}` }"
          @click="openItemChoosed(index + 1)"
        >
          <v-icon 
            :color="selectedItem === `page${index + 1}` ? 'white' : '#0d2c6d'" 
            class="menu-icon"
          >
            {{ item.icon }}
          </v-icon>
          <span class="menu-text">{{ item.title }}</span>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      routerSelected: String
    },
    data: () => ({
      selectedItem: "page1",
      menuItems: [
        { title: "ניהול משתמשים", icon: "mdi-account-group" },
        { title: "מאגר מספרים", icon: "mdi-phone-in-talk" },
        { title: "חיפוש מספר", icon: "mdi-magnify" }
      ]
    }),
    methods: {
      openItemChoosed(itemNum) {
        if (this.$route.params.page !== `page${itemNum}`) {
          this.$router.replace({ name: `agent`, params: { page: `page${itemNum}` } });
          this.selectedItem = `page${itemNum}`;
          this.$emit('barUploadItemSelected', "page" + itemNum);
        }
      }
    },
    mounted() {
      // Check if the window width is less than or equal to 600px
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },
    methods: {
      openItemChoosed(itemNum) {
        if (this.$route.params.page !== `page${itemNum}`) {
          this.$router.replace({ name: `agent`, params: { page: `page${itemNum}` } });
          this.selectedItem = `page${itemNum}`;
          this.$emit('barUploadItemSelected', "page" + itemNum);
        }
      },
      handleResize() {
        // This method is kept for compatibility but we're using CSS for responsiveness
      }
    },
    created() {
      this.selectedItem = this.routerSelected;
    }
  }
  </script>
  
  <style scoped>
  .agent-menu-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
    direction: rtl;
    font-family: 'Heebo', sans-serif;
  }
  
  .agent-menu {
    display: flex;
    width: 90%;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .menu-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 16px 12px;
    flex: 1;
    background-color: white;
    transition: all 0.3s ease;
    cursor: pointer;
    border-left: 1px solid rgba(0, 0, 0, 0.05);
    gap: 8px;
  }
  
  .menu-item:last-child {
    border-left: none;
  }
  
  .menu-item:hover {
    background-color: rgba(13, 44, 109, 0.1);
  }
  
  .menu-item.active {
    background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
  }
  
  .menu-icon {
    font-size: 20px;
  }
  
  .menu-text {
    font-size: 16px;
    font-weight: 600;
    color: #0d2c6d;
    white-space: nowrap;
  }
  
  .menu-item.active .menu-text {
    color: white;
  }
  
  /* Responsive adjustments */
  @media (max-width: 960px) {
    .menu-text {
      font-size: 14px;
    }
    
    .menu-icon {
      font-size: 18px;
    }
    
    .menu-item {
      padding: 14px 8px;
    }
  }
  
  @media (max-width: 768px) {
    .menu-item {
      flex-direction: column;
      padding: 12px 8px;
    }
    
    .menu-text {
      font-size: 12px;
      text-align: center;
    }
  }
  
  @media (max-width: 600px) {
    .agent-menu {
      flex-wrap: wrap;
    }
    
    .menu-item {
      min-width: 50%;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }
    
    .menu-item:nth-child(2n) {
      border-left: none;
    }
    
    .menu-item:nth-child(3) {
      min-width: 100%;
      border-left: none;
    }
  }
  </style>